export enum TipoServicoCamada {
  WMS = 1,
  ESRI_REST,
  IMAGEM,
  WMTS
}
